import { Component, OnInit } from '@angular/core';
import { IvaPagProvService, PageBusquedaObject } from './iva-pag-prov.service';
import { LoginService } from '../../../login/login.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-iva-pag-prov',
  templateUrl: './iva-pag-prov.component.html',
  styleUrls: ['./iva-pag-prov.component.css'],
  providers: [IvaPagProvService]
})
export class IvaPagProvComponent implements OnInit {
  cuenta_contable_txt: String = '';
  cuenta_contable_txt_nombre: String = '';
  cuenta_contable_id: number = 0;
  ctb_tpol_grupo_id: number = 1;
  fecha_inicial: String = '';
  fecha_final: String = '';
  gral_emp_id: number = 16;
  reporte: [] = [];
  tpolGrupos: any[] = [{}];
  busquedaCuentasPadres: PageBusquedaObject = new PageBusquedaObject();
  lista_cuentas: any[] = [];
  lista_temporal: any[] = [];
  constructor(private ivaPagProvService: IvaPagProvService, private loginService: LoginService) {
    this.gral_emp_id = this.loginService.usuario.empresa_seleccionada.id;

  }

  ngOnInit(): void {
    this.getInicioYFinMes();
    this.cargarGrupos();
  }

  // Setear las fechas iniciales y finales respecto al mes actual detectado
  getInicioYFinMes() {
    const fechaActual = new Date();
    const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    const ultimoDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);
    this.fecha_inicial = this.formatoFecha(primerDiaMes);
    this.fecha_final = this.formatoFecha(ultimoDiaMes);

  }

  // Función para formatear la fecha en formato YYYY-MM-DD requerido por el api 
  formatoFecha(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    return `${año}-${mes}-${dia}`;
  }
  //Metodo para hacer la petición al API del reporte
  cargarReporteIvaPagado() {
    this.mostrarMensajeCarga();
    this.ivaPagProvService.getRepIvaPag(this.gral_emp_id, this.ctb_tpol_grupo_id, this.cuenta_contable_id, this.fecha_inicial, this.fecha_final).subscribe(
      response => {
        this.reporte = response.contenido;
        console.log(response);
        this.cerrarMensajeCarga();
      }
    );
  }


  //Cargar los grupos de póliza
  cargarGrupos() {
    this.ivaPagProvService.tpolGetGrupo().subscribe(response => {
      this.tpolGrupos = response;
      {
        this.ctb_tpol_grupo_id = this.tpolGrupos[0].id;
      }
      this.cargarReporteIvaPagado();
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
    });
  }
  asignarCuenta(campo: String) {
    this.busquedaCuentasPadres = new PageBusquedaObject();
    this.busquedaCuentasPadres.criteriaSearch = {};
    if (campo == 'cuenta') {
      this.busquedaCuentasPadres.criteriaSearch['cuenta'] = this.cuenta_contable_txt;
      this.busquedaCuentasPadres.criteriaSearch['nombre'] = '';
    } else {
      this.busquedaCuentasPadres.criteriaSearch['nombre'] = this.cuenta_contable_txt_nombre;
      this.busquedaCuentasPadres.criteriaSearch['cuenta'] = '';
    }
    this.busquedaCuentasPadres.itemsPerPage = 5;
    this.busquedaCuentasPadres.pageNumber = 0;
    this.busquedaCuentasPadres.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuentasPadres.criteriaSearch['emp'] = this.loginService.empresa;
    this.ivaPagProvService.ctaCatalogo(this.busquedaCuentasPadres).subscribe(response => {
      this.lista_cuentas = response.contenido.content;
      if (campo == 'cuenta') {
      if (this.busquedaCuentasPadres.criteriaSearch['cuenta'] === this.lista_cuentas[0].cuenta) {
        this.cuenta_contable_id = this.lista_cuentas[0].id;
        this.cuenta_contable_txt = this.lista_cuentas[0].cuenta;
        this.cuenta_contable_txt_nombre = this.lista_cuentas[0].nombre;
        this.lista_cuentas = [];
      }
    } else {
      if (this.busquedaCuentasPadres.criteriaSearch['nombre'] === this.lista_cuentas[0].nombre) {
        this.cuenta_contable_id = this.lista_cuentas[0].id;
        this.cuenta_contable_txt = this.lista_cuentas[0].cuenta;
        this.cuenta_contable_txt_nombre = this.lista_cuentas[0].nombre;
        this.lista_cuentas = [];
      }
      }
      
    },
      err => {
        if (err.error.mensaje == null) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'Mensaje',
          text: err.error.mensaje
        })
        console.log(err);
      });
  }
  exportAsXLSX() {

    // Crear hoja de cálculo
    const wb = XLSX.utils.book_new(); // Crea un nuevo libro de Excel
    const dataRows = this.convertirJSONaArreglo(this.reporte);
    const ws = XLSX.utils.aoa_to_sheet(dataRows);
    XLSX.utils.book_append_sheet(wb, ws, 'Reporte'); // Agrega la hoja de cálculo al libro

    // Establecer el ancho de las columnas manualmente en el orden del JSON
    ws['!cols'] = [
      { width: 20 },  // folio_poliza
      { width: 30 },  // titulo
      { width: 50 },  // concepto_poliza
      { width: 15 },  // fecha_poliza
      { width: 30 },  // iva_causado_poliza
      { width: 15 },  // serie_folio
      { width: 20 },  // rfc
      { width: 30 },  // cliente
      { width: 15 },  // fecha_cfdi
      { width: 15 },  // metodo_pago
      { width: 30 },  // monto_total_pagos
      { width: 30 },  // total_traslados_base_iva16
      { width: 30 },  // total_traslados_impuesto_iva16
      { width: 30 },  // total_traslados_base_iva8
      { width: 30 },  // total_traslados_impuesto_iva8
      { width: 30 },  // total_traslados_base_iva0
      { width: 30 },  // total_traslados_impuesto_iva0
      { width: 30 }  // total_traslados_base_iva_exento
    ];

  // Aplicar filtros a la hoja de cálculo
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: 0, c: dataRows[0].length - 1 } }) };

  // Aplicar estilo en negrita a los títulos de las columnas
  const headerStyle = { font: { bold: true } };
  const headerRange = XLSX.utils.decode_range(ws['!ref']);
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const headerCell = XLSX.utils.encode_cell({ r: headerRange.s.r, c: col });
    ws[headerCell].s = headerStyle;
  }


    XLSX.writeFile(wb, this.loginService.empresa_info_actual.titulo.toLowerCase().replace(/\s+/g, '_') + '_iva_pagado_a_proveedor_' + this.fecha_inicial + '_a_' + this.fecha_final + '.xlsx'); // Descarga el archivo Excel con el nombre proporcionado
  }

  convertirJSONaArreglo(jsonData: any[]): any[][] {
    const headerRow = [
      'Folio Póliza',
      'Titulo Póliza',
      'Concepto Póliza',
      'Fecha Póliza',
      'TOTAL: ' + this.cuenta_contable_txt_nombre,
      'Serie y Folio',
      'Rfc Proveedor',
      'Nombre Proveedor',
      'Fecha CFDI',
      'Metodo Pago',
      'Monto Total Pagos',
      'Total Traslados Base IVA16',
      'Total Traslados Impuesto IVA16',
      'total Traslados Base IVA8',
      'total Traslados Impuesto IVA8',
      'total Traslados Base IVA0',
      'total Traslados Impuesto IVA0',
      'total Traslados Base IVA EXENTO'
    ];

    const dataRows = jsonData.map(item => [
      item.folio_poliza,
      item.titulo,
      item.concepto_poliza,
      item.fecha_poliza,
      item.iva_causado_poliza,
      item.serie_folio,
      item.rfc,
      item.proveedor,
      item.fecha_cfdi,
      item.metodo_pago,
      item.monto_total_pagos,
      item.total_traslados_base_iva16,
      item.total_traslados_impuesto_iva16,
      item.total_traslados_base_iva8,
      item.total_traslados_impuesto_iva8,
      item.total_traslados_base_iva0,
      item.total_traslados_impuesto_iva0,
      item.total_traslados_base_iva_exento
    ]);

    return [headerRow, ...dataRows];
  }
  mostrarMensajeCarga() {
    Swal.fire({
      title: 'Mensaje',
      html: 'Cargando Reporte...',
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    Swal.close();
  }
}
